/* eslint-disable react/prop-types */
import classes from "./page-type-two.module.scss";
import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewSix from "@/composed-views/composed-view-six";
import ComposedViewFive from "@/composed-views/composed-view-five";
function PageTypeTwo({ content }) {
  return (
    <Flex
      align="flex-start"
      className={classes.simest}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={content.header.header}
        title={content.header.title}
        subTitle={content.header.subTitle}
      />

      <ComposedViewSix
        header={content.capitalGoods.header}
        title={content.capitalGoods.title}
        columnOneTitle={content.capitalGoods.columnOneTitle}
        columnOne={content.capitalGoods.columnOne}
        columnTwoTitle={content.capitalGoods.columnTwoTitle}
        columnTwo={content.capitalGoods.columnTwo}
        subContent={content.capitalGoods.subContent}
        className={classes.capitalGoods}
      />

      {content.externalink && (
        <ComposedViewFive
          title={content.externalink.title}
          button={content.externalink.button}
          className={classes.discover}
        />
      )}
    </Flex>
  );
}

export default PageTypeTwo;
